import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from "../_virtual/_rollupPluginBabelHelpers.js";
var BandwidthService = /* @__PURE__ */ function() {
  function BandwidthService2() {
    _classCallCheck(this, BandwidthService2);
    _defineProperty(this, "_chunkSpeeds", []);
    _defineProperty(this, "_speeds", []);
  }
  _createClass(BandwidthService2, [{
    key: "addRecord",
    value: function addRecord(totalByte, ms) {
      if (!totalByte || !ms)
        return;
      this._speeds.push(8e3 * totalByte / ms);
      this._speeds = this._speeds.slice(-3);
    }
  }, {
    key: "addChunkRecord",
    value: function addChunkRecord(totalByte, ms) {
      if (!totalByte || !ms)
        return;
      this._chunkSpeeds.push(8e3 * totalByte / ms);
      this._chunkSpeeds = this._chunkSpeeds.slice(-100);
    }
  }, {
    key: "getAvgSpeed",
    value: function getAvgSpeed() {
      if (!this._chunkSpeeds.length && !this._speeds.length)
        return 0;
      if (this._speeds.length) {
        return this._speeds.reduce(function(a, c) {
          return a += c;
        }) / this._speeds.length;
      }
      return this._chunkSpeeds.reduce(function(a, c) {
        return a += c;
      }) / this._chunkSpeeds.length;
    }
  }, {
    key: "getLatestSpeed",
    value: function getLatestSpeed() {
      if (!this._chunkSpeeds.length && !this._speeds.length)
        return 0;
      if (this._speeds.length) {
        return this._speeds[this._speeds.length - 1];
      }
      return this._chunkSpeeds[this._chunkSpeeds.length - 1];
    }
  }, {
    key: "reset",
    value: function reset() {
      this._chunkSpeeds = [];
      this._speeds = [];
    }
  }]);
  return BandwidthService2;
}();
export { BandwidthService };
